<script setup lang="ts">
import { Button } from '@forgd/ui-kit/button'
import { Separator } from '@forgd/ui-kit/separator'

const { registerData } = useLoginModal()
const supabase = useSupabaseClient()
const toast = useAppToast()

const resending = ref(false)

async function resend() {
  if (resending.value) {
    return
  }
  resending.value = true
  try {
    const { error } = await supabase.auth.resend({
      email: registerData.email,
      type: 'signup',
    })
    if (error) {
      toast.error(error.message)
    }
    else {
      toast.success('Confirmation email sent. Please check your inbox.')
    }
  }
  finally {
    resending.value = false
  }
}
</script>

<template>
  <div class="flex h-full w-full flex-col">
    <div class="flex flex-1 flex-col items-center justify-center gap-4 text-center font-display">
      <img
        src="/auth/verify-email.svg"
        alt=""
        aria-hidden="true"
        class="h-40"
      >
      <div>
        <h1 class="text-lg font-semibold text-primal">
          Confirm your email to continue
        </h1>
        <p class="mt-1 text-sm text-secondary">
          We’ve sent a confirmation email to <b>{{ registerData.email }}</b> with a link to
          activate your account and finish setting up.
        </p>
      </div>
    </div>

    <div class="space-y-4">
      <Separator />
      <p class="text-sm text-secondary">
        Didn’t receive an email, please review your spam folder, or send it again.
      </p>
      <Button
        size="lg"
        class="h-12"
        block
        :loading="resending"
        @click="resend"
      >
        Resend Email
      </Button>
    </div>
  </div>
</template>
